import { z } from 'zod';
export const SearchHitTypeSchema = z.enum([
    'CLIENT',
    'OPPORTUNITY',
    'DOCUMENT',
    'EMAIL',
    'INVOICE',
    'EXPENSE',
]);
export const SearchHitSchema = z.object({
    type: SearchHitTypeSchema,
    id: z.string(),
    title: z.string(),
    /** Texto secundario corto (código, asunto, fecha…). */
    subtitle: z.string().nullable(),
    /** Snippet con el contexto donde aparece la búsqueda. */
    snippet: z.string().nullable(),
    /** Ruta interna a la que navegar al pulsar el resultado. */
    href: z.string(),
});
export const SearchResponseSchema = z.object({
    query: z.string(),
    groups: z.object({
        clients: z.array(SearchHitSchema),
        opportunities: z.array(SearchHitSchema),
        documents: z.array(SearchHitSchema),
        emails: z.array(SearchHitSchema),
        invoices: z.array(SearchHitSchema),
        expenses: z.array(SearchHitSchema),
    }),
    total: z.number().int().nonnegative(),
});
//# sourceMappingURL=search.js.map